import React from 'react';
import { FormGroup, FormInput, ModalBody } from 'shards-react';

interface ModalEditBodyProps {
  label: string;
  value: string;
  invalid: boolean;
  invalidText: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ModalEditBody = ({ label, value, invalid, invalidText, onChange }: ModalEditBodyProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(d);
  // }, [d]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalBody>
      <FormGroup>
        <label htmlFor="organizationBasename">{label}</label>
        <FormInput id="organizationBasename" className="mb-3" value={value} invalid={invalid} onChange={onChange} />
      </FormGroup>
      {invalid && <span>{invalidText}</span>}
    </ModalBody>
  );
};

export default ModalEditBody;
